<div class="forgot-password-content">
  <div class="forgot-password-content__header">
    <h2 class="forgot-password-content__title">Reset Your Password</h2>
    @if (!isSent()) {
      <p class="forgot-password-content__subtitle">
        Enter your email address and we'll send you a link to reset your password.
      </p>
    }
  </div>

  @if (!isSent()) {
    <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="forgot-password-content__form" data-testid="forgot-password-form">
      <mat-form-field appearance="outline" class="forgot-password-content__field">
        <mat-label>Email Address</mat-label>
        <input
          matInput
          type="email"
          formControlName="email"
          placeholder="Enter your email address"
          autocomplete="email"
          data-testid="email-input"
        />
        <mat-icon matSuffix>email</mat-icon>
        @if (emailControl.hasError('required')) {
          <mat-error data-testid="email-required-error"> Email is required </mat-error>
        } @else if (emailControl.hasError('email')) {
          <mat-error data-testid="email-invalid-error"> Please enter a valid email address </mat-error>
        }
      </mat-form-field>

      <div class="forgot-password-content__actions">
        <wil-cta-button
          [loading]="isSubmitting()"
          [disabled]="!canSubmit"
          [ctaText]="isSubmitting() ? 'Sending...' : 'Send Reset Link'"
          (ctaClick)="onSubmit()"
          [style]="'primary'"
          [size]="'large'"
          data-testid="forgot-password-content-submit-button"
        ></wil-cta-button>

        <button
          type="button"
          mat-button
          class="forgot-password-content__back-button"
          (click)="onBackToLogin()"
          data-testid="back-to-login-button"
        >
          <mat-icon>arrow_back</mat-icon>
          Back to Login
        </button>
      </div>
    </form>
  }

  @if (isSent()) {
    <div class="forgot-password-content__confirmation" data-testid="confirmation-state">
      <div class="forgot-password-content__confirmation-icon">
        <mat-icon color="primary">mark_email_read</mat-icon>
      </div>

      <h3 class="forgot-password-content__confirmation-title">Check Your Email</h3>

      <p class="forgot-password-content__confirmation-message">If an account exists for this email, we'll send a reset link.</p>

      <div class="forgot-password-content__confirmation-actions">
        <wil-cta-button
          [ctaText]="'Back to Login'"
          (ctaClick)="onBackToLogin()"
          [style]="'secondary'"
          [size]="'large'"
          data-testid="confirmation-back-to-login-button"
        ></wil-cta-button>
      </div>
    </div>
  }
</div>
